import { useEffect, useState } from "react";
import { Eye, Download } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Section, NativeSelect, Empty } from "../common";
import { errMsg, openPdf, downloadPdf, useFetch } from "../../lib/api";
import { useT } from "../../lib/i18n";

export default function PdfTab({ q }) {
  const { t } = useT();
  const { data: revs } = useFetch(`/quotations/${q.id}/revisions`);
  const [src, setSrc] = useState(null);
  const [label, setLabel] = useState("");
  const [rev, setRev] = useState("");
  useEffect(() => () => { if (src) URL.revokeObjectURL(src); }, [src]);
  const show = async (url, lbl) => {
    try { setSrc(await openPdf(url)); setLabel(lbl); } catch (e) { toast.error(errMsg(e)); }
  };
  const sel = (revs || []).find((r) => String(r.rev) === rev);
  return (
    <Section title={t("ws.pdf")} testid="section-pdf" right={
      <div className="flex flex-wrap items-center gap-2">
        <Button size="sm" variant="outline" data-testid="pdf-preview-draft-btn" onClick={() => show(`/quotations/${q.id}/preview-pdf`, t("ws.pdfPreview"))}><Eye className="h-4 w-4" />{t("ws.pdfPreview")}</Button>
        {!!revs?.length && <>
          <div className="w-full sm:w-44"><NativeSelect testid="pdf-rev-select" value={rev} placeholder={t("ws.pdfRev")} onChange={(v) => setRev(v || "")} options={revs.map((r) => ({ value: String(r.rev), label: `Rev ${r.rev}` }))} /></div>
          <Button size="sm" data-testid="pdf-view-rev-btn" disabled={!rev} onClick={() => show(`/quotations/${q.id}/revisions/${rev}/pdf`, `${t("ws.pdfRev")} ${rev}`)}>{t("common.view")}</Button>
          <Button size="sm" variant="outline" data-testid="pdf-download-rev-btn" disabled={!rev}
            onClick={() => downloadPdf(`/quotations/${q.id}/revisions/${rev}/pdf`, `${q.folio}-Rev${rev}.pdf`).catch((e) => toast.error(errMsg(e)))}><Download className="h-4 w-4" />{t("ws.downloadPdf")}</Button>
        </>}
      </div>}>
      {sel && label.startsWith(t("ws.pdfRev")) && <div className="mb-2 font-mono text-[11px] text-neutral-500" data-testid="pdf-hash">{t("ws.hash")}: {sel.pdf_sha256}</div>}
      {src ? <iframe title="pdf" data-testid="pdf-iframe" src={src} className="h-[80vh] w-full rounded border border-neutral-200" />
        : <Empty>{revs?.length ? "—" : t("ws.noRevisions")}</Empty>}
    </Section>
  );
}
